import { CloseSquareOutlined, UnorderedListOutlined } from "@ant-design/icons";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  Layout,
  Row,
  Space,
  Spin,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import { rightAction } from "../../../redux/actions";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import Notiflix from "notiflix";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const getBatchStatusCode = (status) =>
  String(status ?? "")
    .trim()
    .charAt(0)
    .toUpperCase();

const isSameAsToday = (date) => {
  const parsedDate = dayjs(date);

  return parsedDate.isValid() && parsedDate.isSame(dayjs(), "day");
};

function BranchBatch(props) {
  const { userData, rightBtn } = props;
  const { session } = userData;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [batchStatus, setBatchStatus] = useState("");
  const [batchUser, setBatchUser] = useState("");
  const [template, setTemplate] = useState({});
  console.log(batchStatus);

  useEffect(() => {
    getBranchCode();
  }, []);

  const getBranchCode = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.BranchBatch}?officeId=1`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        const objList = res;
        console.log(objList);
        setBatchStatus(objList?.batchStatus);
        setBatchUser(objList?.batchUser?.id);
        setTemplate(objList);

        form.setFieldsValue({
          branchCode: objList?.branchCode?.externalId,
          batchStatus: objList?.batchStatus,
        });
        setLoading(false);
      }
    });
  };

  const onSubmit = (values) => {
    const isReopeningClosedBatchToday =
      values?.batchStatus === "O" &&
      getBatchStatusCode(template?.batchStatus) === "C" &&
      isSameAsToday(template?.businesDate ?? template?.businessDate);

    const payload = {
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      businesDate: BOM.DateTime(values.date, "only-date"),
      branchCode: values?.branchCode,
      batchStatus: values?.batchStatus,
      batchId: template?.id,
      id: template?.id,
      batchUser: batchUser,
      method:
        values?.batchStatus === "O" && !isReopeningClosedBatchToday
          ? "POST"
          : "PUT",
      session,
    };

    console.log(payload);

    const url = `${apiConfig.BranchBatch}?officeId=1`;

    setLoading(true);
    BOM.FetchReqAction(payload, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Branch batch updated successfully");
        // setBatchStatus(values?.batchStatus);
        form.setFieldsValue({
          batchStatus: values?.batchStatus,
        });
        getBranchCode();
        setLoading(false);
        form.resetFields();
      }
    });
  };

  const handleOpenBatch = () => {
    let action = "Open  ";
    let label = "Branch Batch";

    form.validateFields(["date"]).then(() => {
      Notiflix.Confirm.show(
        "Are you sure?",
        action + label,
        "Yes",
        "No",
        () => {
          onSubmit({
            ...form.getFieldsValue(),
            batchStatus: "O",
          });
        },
      );
    });
  };

  const handleCloseBatch = () => {
    let action = "Close  ";
    let label = "Branch Batch";

    form.validateFields(["date"]).then(() => {
      Notiflix.Confirm.show(
        "Are you sure?",
        action + label,
        "Yes",
        "No",
        () => {
          onSubmit({
            ...form.getFieldsValue(),
            batchStatus: "C",
          });
        },
      );
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={false}
      pageItems={staticConfig.branchBatchItems}
    >
      <TopContent
        pageTitle={labelConfig.manageBranchBatch}
        //  createPageTitle={labelConfig.createMoneyMarketBond}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={loading}>
          <Form
            form={form}
            layout="vertical"
            // onFinish={onSubmit}
          >
            <Row justify="end" style={{ marginBottom: 16 }}>
              <Button
                className="of-primaryBtnColor"
                style={{
                  width: "10%",
                }}
                icon={<UnorderedListOutlined />}
                htmlType="button"
                disabled={batchStatus === "O"}
                onClick={handleOpenBatch}
              >
                Open Batch
              </Button>
              <Button
                className="of-primaryBtnColor"
                style={{
                  width: "10%",
                  marginLeft: 10,
                }}
                icon={<CloseSquareOutlined />}
                htmlType="button"
                disabled={batchStatus === "C"}
                onClick={handleCloseBatch}
              >
                Close Batch
              </Button>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="date"
                  label={<Text strong>Date</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ marginBottom: 0, width: "100%" }}
                    disabledDate={BOM.DisabledAfterCurrentDate}
                    placeholder="Select date"
                    suffixIcon={<CalendarIcon color="#667085" width={20} />}
                    className="bond-date-picker custom-input"
                  />
                </Form.Item>

                <Form.Item name="batchStatus" hidden>
                  <Input />
                </Form.Item>

                <Form.Item
                  name="branchCode"
                  label={<Text strong>Branch Code</Text>}
                >
                  <Input
                    className="of-bold-disable-input"
                    disabled
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(BranchBatch);
